import { ofType, combineEpics } from "redux-observable";
import * as RxOp from "rxjs/operators";
import * as Rx from "rxjs";
import S from "sanctuary";

import { customerSearchAsOkta } from "@/APIClient";
import { requestEpic } from "@/APIClient/observable.util";
import { getCurrentUserClientSlug } from "@/components/currentUser/CurrentUser.state";
import { getAuthToken } from "@/util/session";

import {
  REQUEST_SEARCH,
  PERFORM_SEARCH,
  REQUEST_PAGINATED_SEARCH,
  PAGE_NEXT,
  PAGE_PREVIOUS,
  SET_CURRENT_PAGE,
  requestPaginatedSearch,
  getCurrentPage,
  setSearchRequestPending,
  setSearchRequestSucceeded,
  setSearchRequestFailed,
  getCurrentCriteria,
  setCustomerSearchResults,
} from "./CustomerSearchPage.state";

const RESULTS_PER_PAGE = 20;

const pagination = (pageNumber = 1) => ({
  pageNumber,
  pageSize: RESULTS_PER_PAGE,
});

const userInfo = (state) => ({
  token: S.fromMaybe("")(getAuthToken(state)),
  clientSlug: getCurrentUserClientSlug(state),
});

const searchParams = (state, page) => ({
  ...userInfo(state),
  ...pagination(page),
  ...getCurrentCriteria(state),
});

const performCustomerSearchEpic = (action$, state$) =>
  action$.pipe(
    ofType(REQUEST_SEARCH, REQUEST_PAGINATED_SEARCH),
    RxOp.mergeMap(({ payload = {} }) =>
      Rx.concat([
        Rx.of(setSearchRequestPending()),
        requestEpic({
          requestMethod: customerSearchAsOkta,
          requestArgs: searchParams(state$.value, payload.page),
          onSuccess: (result) =>
            Rx.of(
              setSearchRequestSucceeded(),
              setCustomerSearchResults({
                customers: result.value.data.value,
                customersMeta: result.value.meta.value,
                page: payload.page || 1,
              })
            ),
          onFailure: (error) =>
            Rx.of(setSearchRequestFailed({ error: error.value })),
        }).pipe(RxOp.takeUntil(action$.pipe(ofType(PERFORM_SEARCH)))),
      ])
    ),
    RxOp.concatAll()
  );

const searchOnPageChangeEpic = (action$, state$) =>
  action$.pipe(
    ofType(PAGE_NEXT, PAGE_PREVIOUS, SET_CURRENT_PAGE),
    RxOp.map(() => requestPaginatedSearch({ page: getCurrentPage(state$.value) })),
    RxOp.catchError((e) => console.error(e))
  );

export default combineEpics(performCustomerSearchEpic, searchOnPageChangeEpic);
